import React, { useEffect, useState } from "react";

//package import

import { HashRouter as Router, Route, Routes } from "react-router-dom";

//user import

import {
	Login,
	AdminPortal,
	MinistryAdminPortal,
	DistrictAdminPortal,
	ProvinceAdminPortal,
	SetPaassword,
	PouAdminPortal,
} from "./pages";
import { RoutesUrls } from "./Services/Routes/APP";
import ThemeProvider from "./theme";
import { PrivateRouteWrapper } from "./Services/Routes/APP/PrivateRoute";
import { App as CapacitorApp } from "@capacitor/app";



//component

function App() {
	//render
	const [refreshLayout, setRefreshLayout] = useState(false);

	  CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      if (!canGoBack) {
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });

	return (
		<div id="app">
			<ThemeProvider>
				<div
					id="layout-refresher"
					onClick={() => {
						setRefreshLayout(!refreshLayout);
					}}
					style={{
						maxWidth: 0,
						maxHeight: 0,
						display: refreshLayout ? "block" : "none",
						visibility: refreshLayout ? "hidden" : "visible",
					}}
				></div>
				<Router>
					<Routes>
						<Route caseSensitive path={RoutesUrls?.root} element={<Login />} />
						<Route
							caseSensitive
							path={RoutesUrls?.userConfirmation}
							element={<SetPaassword />}
						/>
						<Route
							path={`${RoutesUrls?.admin}/*`}
							element={
								<PrivateRouteWrapper>
									<AdminPortal />
								</PrivateRouteWrapper>
							}
						/>
						<Route
							path={`${RoutesUrls?.ministryAdmin}/*`}
							element={
								<PrivateRouteWrapper>
									<MinistryAdminPortal />
								</PrivateRouteWrapper>
							}
						/>
						<Route
							path={`${RoutesUrls?.provinceAdmin}/*`}
							element={
								<PrivateRouteWrapper>
									<ProvinceAdminPortal />
								</PrivateRouteWrapper>
							}
						/>
						<Route
							path={`${RoutesUrls?.districtAdmin}/*`}
							element={
								<PrivateRouteWrapper>
									<DistrictAdminPortal />
								</PrivateRouteWrapper>
							}
						/>
						<Route
							path={`${RoutesUrls?.pouAdmin}/*`}
							element={
								<PrivateRouteWrapper>
									<PouAdminPortal />
								</PrivateRouteWrapper>
							}
						/>
					</Routes>
				</Router>
			</ThemeProvider>
		</div>
	);
}

export default App;
